import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useIntl } from 'react-intl';

import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

import TSTable from '@ts-core/components/Table/TSTable';

const AcademyBilledCoursesTable = (props) => {
  const intl = useIntl();
  const { courses, loading, onSelectCourse } = props;

  const totalStudents = courses.reduce(
    (total, course) => total + course.totalStudents,
    0
  );
  const totalDebt = courses.reduce(
    (total, course) => total + course.totalDebt,
    0
  );

  const columns = useMemo(
    () => [
      {
        Header: intl.formatMessage({ id: 'billing.coursesTable.name' }),
        value: intl.formatMessage({ id: 'billing.coursesTable.name' }),
        accessor: 'name',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'billing.coursesTable.owner' }),
        value: intl.formatMessage({ id: 'billing.coursesTable.owner' }),
        accessor: 'owner.name',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'billing.coursesTable.periodStatus' }),
        value: intl.formatMessage({ id: 'billing.coursesTable.periodStatus' }),
        accessor: 'periodStatus',
        sortable: true,
        valueTransformer: (value) => {
          return value === 'opened' ? <LockOpenIcon /> : <LockIcon />;
        },
      },
      {
        Header: intl.formatMessage({ id: 'billing.coursesTable.periodStart' }),
        value: intl.formatMessage({ id: 'billing.coursesTable.periodStart' }),
        accessor: 'periodDateInit',
        sortable: true,
        valueTransformer: (value) => {
          return moment(value).format('DD/MM/YYYY');
        },
      },
      {
        Header: intl.formatMessage({ id: 'billing.coursesTable.periodEnd' }),
        value: intl.formatMessage({ id: 'billing.coursesTable.periodEnd' }),
        accessor: 'periodDateEnd',
        sortable: true,
        valueTransformer: (value) => {
          return value ? moment(value).format('DD/MM/YYYY') : '-';
        },
      },
      {
        Header: intl.formatMessage({
          id: 'courseInvoiceDetails.table.duration',
        }),
        value: intl.formatMessage({
          id: 'courseInvoiceDetails.table.duration',
        }),
        accessor: 'periodDuration',
        sortable: true,
      },
      {
        Header: intl.formatMessage({
          id: 'billing.coursesTable.billableStudents',
        }),
        value: intl.formatMessage({
          id: 'billing.coursesTable.billableStudents',
        }),
        accessor: 'totalStudents',
        sortable: true,
        Footer: `${totalStudents}`,
      },
      {
        Header: intl.formatMessage({
          id: 'billing.coursesTable.cost',
        }),
        value: intl.formatMessage({
          id: 'billing.coursesTable.cost',
        }),
        accessor: 'totalDebt',
        sortable: true,
        valueTransformer: (value) => `$${value}`,
        Footer: `$${totalDebt}`,
      },
    ],
    [intl, totalDebt, totalStudents]
  );

  return (
    <TSTable
      data={courses}
      columns={columns}
      loading={loading}
      onSelectRow={onSelectCourse}
    />
  );
};

AcademyBilledCoursesTable.propTypes = {
  courses: PropTypes.array.isRequired,
  loading: PropTypes.bool,

  onSelectCourse: PropTypes.func.isRequired,
};

AcademyBilledCoursesTable.defaultProps = {
  loading: false,
};

export default AcademyBilledCoursesTable;
